import classNames from 'classnames';
import { forwardRef } from 'react';
const mobileShellContentCss = "m1sde5t0";
export const MobileShellContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(mobileShellContentCss, props.className)} />;
});
const navigatorItemsCss = "nlbep3y";
export const NavigatorItems = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(navigatorItemsCss, props.className)} />;
});
const navigatorLeadingCss = "n1l7pcfy";
export const NavigatorLeading = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(navigatorLeadingCss, props.className)} />;
});
const navigatorTitleCss = "n1vdirh7";
export const NavigatorTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(navigatorTitleCss, props.className)} />;
});
const navigatorWrapperCss = "nznhrgn";
export const NavigatorWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(navigatorWrapperCss, props.className)} />;
});

require("./mobile_shell_styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./mobile_shell_styles.js");